// The same rule the backend applies (crm-django `normalize_phone`), checked here so the
// form can say what is wrong before the save. The backend turns any number that does not
// start with +48 into a +1 one, so a Polish number typed without its +48 would be dialled
// as a US number.
const SEPARATORS = /[\s().-]/g;
const INTERNATIONAL = /^(\+48\d{9}|\+1\d{10})$/;
const US_LOCAL = /^1?\d{10}$/;

export const DEFAULT_PHONE_PREFIX = '+48';

const compact = (value: string) => value.replace(SEPARATORS, '');

export const isSupportedPhone = (value: string) => {
  const digits = compact(value);
  return INTERNATIONAL.test(digits) || US_LOCAL.test(digits);
};

/** Empty, or only the pre-filled prefix: an optional field the user left untouched. */
export const isBlankPhone = (value: string | undefined) => {
  const digits = compact(value ?? '');
  return digits === '' || digits === DEFAULT_PHONE_PREFIX;
};

/** antd Form rule. An empty value passes; pair it with `required` where one is needed. */
export const phoneRule = (message: string, options: { optional?: boolean } = {}) => ({
  validator: (_: unknown, value: string | undefined) => {
    if (!value || (options.optional && isBlankPhone(value)) || isSupportedPhone(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(message));
  },
});
